<template>
  <div>
    <div id="calendar" v-if="!isShow">
      <ul class="weekdays">
        <li>一</li>
        <li>二</li>
        <li>三</li>
        <li>四</li>
        <li>五</li>
        <li>六</li>
        <li>日</li>
      </ul>
      <ul class="days">
        <li v-for="(day,index) in days" :key="index">
          <!--今天-->
          <!-- <span v-if="day.getMonth()+1 != currentMonth" class="other-month">{{ day.getDate() }}</span> -->
            <!--今天-->
            <el-popover
              v-if="hasClass[index].isClass"
              placement="top-start"
              trigger="hover">
                <p class="month_title" v-html="hasClass[index].content" v-if="hasClass[index].content"></p>
                <span slot="reference"
                v-if="day.getFullYear() == new Date().getFullYear() && day.getMonth() == new Date().getMonth() && day.getDate() == new Date().getDate()"
                class="active"
              >{{ day.getDate() }}</span>
              <span :class="{pitchDay:day==pitchDay,hasClass:hasClass[index].isClass}" slot="reference" v-else>{{ day.getDate() }}</span>
            </el-popover>
            <span slot="reference"
                v-else-if="day.getFullYear() == new Date().getFullYear() && day.getMonth() == new Date().getMonth() && day.getDate() == new Date().getDate()"
                class="active"
              >{{ day.getDate() }}</span>
              <span :class="{pitchDay:day==pitchDay,hasClass:hasClass[index].isClass}" slot="reference" v-else>{{ day.getDate() }}</span>
          <!-- <span v-if="(day.getDate()+'').length<2">0</span> -->
        </li>
      </ul>
      <ul class="describe_box">
        <li>有课</li>
        <li>无课</li>
      </ul>
    </div>
    <div v-else  class="noClass">
      <img src="@/assets/noClass.png" alt="">
      <p>放假中 暂无课表</p>
    </div>
  </div>
</template>

<script>
import {
  getWeekList,
  myAdjustCourse
} from "@/api/common_api";
export default {
  props: {
    obj: {
      type: Object
    }
  },
  data() {
    return {
      days: [],
      hasClass: [],
      option: [],
      value: 0,
      show: false,
      pitchDay: "",
      semester: {},
      week: {},
      index: "",
      weekClass: [],
      isShow:false
    };
  },
  created: function() {
    this.getWeek();
    this.initData('2020-07-03')
  },
  methods: {
    // 获取周列表
    getWeek() {
      getWeekList().then(res => {
        if (res.s == 1) {
          res.d.map((val, index) => {
            val.text = val.name.replace(/-/g, "/");
            if (val.present == 1) {
              this.week = val;
              this.index = index;
            }
            return val;
          });
          this.option = res.d;
          this.getClass();
        }
      });
    },
    getClass() {
      myAdjustCourse({ week: this.week.week}).then(res => {
        if(res.s==1){
          let ary = [
            "一",
            "二",
            "三",
            "四",
            "五",
            "六",
            "七",
            "八",
            "九",
            "十"
          ];
          if(!res.d.length){
            this.isShow = true
          }
          this.weekClass=res.d
          this.hasClass = this.weekClass.map(val => {
            let isClass = val.some(obj => {
              return obj.id;
            });
            let content=""
            val.map((item,index)=>{
              if(index==0 || !Object.keys(item).length){
                return false
              }
              if(content.length){
                content+='<br>'
              }
              content+=`${item.show_schoolTypeName} ${item.class}  第${ary[item.section - 1]}节课${item.subject}`
            })
            return {isClass:isClass,content:content}
          });
          this.initData(this.week.beginDate);
          this.days.map((day,index)=>{
            if(day.getFullYear() == new Date().getFullYear() && day.getMonth() == new Date().getMonth() && day.getDate() == new Date().getDate()){
              this.pick(day,index)
            }
          })
        }
      });
      
    },
    //选择完成
    confirm(obj) {
      this.week = obj;
      this.obj.searchTwoWeek = obj.week
      this.show = false;
      this.getClass()
    },
    initData: function(cur) {
      var date;
      cur = cur.replace(/-/g, '/')
      if (cur) {
        date = new Date(cur);
      } else {
        date = new Date();
      }
      this.currentDay = date.getDate();
      this.currentYear = date.getFullYear();
      this.currentMonth = date.getMonth() + 1;
      this.currentWeek = date.getDay(); // 1...6,0
      if (this.currentWeek == 0) {
        this.currentWeek = 7;
      }
      var str = this.formatDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      );
      // console.log("today:" + str + "," + this.currentWeek);
      this.days.length = 0;
      // 今天是周日，放在第一行第7个位置，前面6个
      for (var i = this.currentWeek - 1; i >= 0; i--) {
        var d = new Date(str);
        d.setDate(d.getDate() - i);
        // console.log("y:" + d.getDate());
        this.days.push(d);
      }
      for (var i = 1; i <= 28 - this.currentWeek; i++) {
        var d = new Date(str);
        d.setDate(d.getDate() + i);
        this.days.push(d);
      }

    },
    // 当前选择日期
    pick(date,index) {
      let week = ['周一','周二','周三','周四','周五','周六','周七']
      this.pitchDay = date;
      this.$emit('clickWeek', {weekClass:this.weekClass[index],date:this.$moment(new Date(date)).format('YYYY年MM月DD日')+week[index%7],week:this.week.week,oldDate:date})
    },
    pickPre: function(year, month) {
      // setDate(0); 上月最后一天
      // setDate(-1); 上月倒数第二天
      // setDate(dx) 参数dx为 上月最后一天的前后dx天
      var d = new Date(this.formatDate(year, month, 1));
      d.setDate(0);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    pickNext: function(year, month) {
      var d = new Date(this.formatDate(year, month, 1));
      d.setDate(35);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    pickYear: function(year, month) {
      alert(year + "," + month);
    },

    // 返回 类似 2016-01-02 格式的字符串
    formatDate: function(year, month, day) {
      var y = year;
      var m = month;
      if (m < 10) m = "0" + m;
      var d = day;
      if (d < 10) d = "0" + d;
      return y + "-" + m + "-" + d;
    }
  }
};
</script>


<style lang="less" scoped>
* {
  box-sizing: border-box;
}

ul {
  list-style-type: none;
}

body {
  font-family: Verdana, sans-serif;
  background: #e8f0f3;
}
#calendar {
  width: 100%;
  margin: 0 auto;
}

.month {
  font-size: 14px;
  padding: 1rem 0rem;
  padding: 0rem 0.75rem;
  p {
    margin: 0;
  }
  & > div {
    display: flex;
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 0.06rem solid #eeeeee;
  }
}

.year-month {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.year-month:hover {
  background: rgba(150, 2, 12, 0.1);
}

.choose-year {
  padding-left: 20px;
  padding-right: 20px;
}

.choose-month {
  text-align: center;
  font-size: 1.5rem;
}

.arrow {
  padding: 30px;
}

.arrow:hover {
  background: rgba(100, 2, 12, 0.1);
}

.month ul li {
  color: white;
  font-size: 20px;
  text-transform: uppercase;
  letter-spacing: 3px;
}

.weekdays {
  margin: 0;
  padding: 10px 0;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  color: #444;
  justify-content: space-around;
  width: 110%;
  margin-left: -5%;
}

.weekdays li {
  display: inline-block;
  width: 13.6%;
  text-align: center;
  font-size: 14Px;
}

.days {
  padding: 0;
  background: #ffffff;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 110%;
  margin-left: -5%;
}

.days li {
  list-style-type: none;
  display: inline-block;
  width: 14.2%;
  text-align: center;
  // padding-bottom: 15px;
  // padding-top: 15px;
  margin-top: 17Px;
  font-size: 18Px;
  color: #444;
  line-height: 28Px;
  color: #05BD78;
}

.days li .active {
  display: inline-block;
  text-align: center;
  width: 28Px;
  height: 28Px;
  border-radius: 50%;
  background: #1890FF;
  color: #fff;
}

.pitchDay {
  display: inline-block;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  border: 1px solid #fe7644;
  box-sizing: border-box;
}

.hasClass{
  color: #1890FF;
}

.days li .other-month {
  padding: 5px;
  color: gainsboro;
}

.describe_box {
  display: flex;
  padding-top:10Px;
  li {
    padding-left: 14Px;
    position: relative;
    font-size: 14Px;
    &::before {
      content: "";
      position: absolute;
      width: 7Px;
      height: 7Px;
      background: #1890FF;
      left: 0;
      top: 6Px;
      border-radius: 50%;
    }
    &:last-child{
      margin-left: 17Px;
      &::before{
        background: #05BD78;
      }
    }
  }
}

.month_title{
  line-height: 32Px;
  font-size: 14Px;
  color: #444;
  text-align: center;
}

.noClass{
  text-align: center;
  p{
    margin: 10Px 0;
  }
}

</style>